module.exports = "_framework/blazor.webassembly.js";